import { AJ_WEB_CONNECTOR } from "Constants";
import {
    t,
    translate,
} from "components/CentralDataMangement/translation/Translation";
import NoRecords from "components/common/atoms/NoRecords";
import PaginationNew from "components/common/atoms/PaginationNew";
import SpinnerWrapper from "components/common/atoms/SpinnerWrapper";
import Title from "components/common/atoms/Title";
import { ApiCall } from "components/common/services/ApiServices";
import AccessControl from "components/common/services/RolesAndPermissions/AccessControl";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import EditIcon from "static/images/EditIcon";
import SearchFields from "components/common/atoms/SearchFields";
import ResetBtn from "components/common/atoms/ResetBtn";
import '../llmModel/css/llmModel.css';
import LinkTo from "components/common/atoms/LinkTo";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { createFilterConfig } from "./Filters";
import { FETCH_LLM } from "routes/ApiEndpoints";
import CustomNotify from "components/common/atoms/CustomNotify";
interface SearchProps {
    name: string;
    currentPage: number;
    recordsPerPage: number;
    archiveStatus: number | null;
    promptType: string;
}

interface LlmPromptsProps {
    name: string;
    id: number;
    promptType: string;
}

const ManageLlmPrompts: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const filters = createFilterConfig();

    // Initialize search data based on query params
    const defaultSearchData: SearchProps = {
        name: "",
        currentPage: 1,
        recordsPerPage: 10,
        archiveStatus: null,
        promptType: ""
    };

    const [paginationData, setPaginationData] = useState({
        totalPages: 1,
        totalRecords: 0,
    });

    const [searchData, setSearchData] = useState<SearchProps>({
        ...defaultSearchData
    });

    const [llmPrompts, setLlmPrompts] = useState<LlmPromptsProps[]>([]);
    //** change handlers */
    const handleSearchChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setSearchData((prevSearch) => ({
            ...prevSearch,
            currentPage: 1,
            [name]: value,
        }));
    };

    const handleItemsPerPageChange = (newItemsPerPage: number) => {
        setSearchData((prev) => ({
            ...prev,
            recordsPerPage: newItemsPerPage,
            currentPage: 1,
        }));
    };

    const handlePageChange = (pageNumber: number) => {
        setSearchData((prevSearch) => ({
            ...prevSearch,
            currentPage: pageNumber,
        }));
    };

    useEffect(() => {
        const filterData = { ...searchData };
        setLoading(true);
        const delayDebounceFn = setTimeout(() => {
            fetchDetails(filterData);
        }, 500);
        return () => clearTimeout(delayDebounceFn);
    }, [searchData]);

    const fetchDetails = async (searchData: any) => {

        setLoading(true);
        const data = {
            search: searchData,
            type: 'prompt'
        };
        const url = FETCH_LLM;
        const response = await ApiCall.service(
            url,
            "POST",
            data,
            false,
            AJ_WEB_CONNECTOR
        );
        if (response?.status == 200) {
            setLlmPrompts(response?.data?.data);
            setPaginationData(response?.data?.pagination)
        } else {
            CustomNotify({
                type: "error",
                message: t("Some error occured"),
            });
        }
        setLoading(false);
    };


    const handleReset = async (e: React.FormEvent) => {
        setSearchData({ ...defaultSearchData });
    };

    return (
        <AccessControl
            requiredPermissions={[
                {
                    permission: "Content creation",
                    read: true,
                },
            ]}
            renderNoAccess={true}
        >
            <>
                <div
                    className={`main-container `}
                >
                    <Title title={t("LLM prompts")} />
                    <div className="position-relative tableMainWrapper">
                        <div className="row">
                            <div className="ManageCreateBtn">
                                <AccessControl
                                    requiredPermissions={[
                                        {
                                            permission: "Content creation",
                                            create: true,
                                        },
                                    ]}
                                >
                                    <LinkTo
                                        pagelink="/llm-prompt"
                                        title={t("Add prompt")}
                                        icon={faPlus}
                                        className="marginRightPoint5"
                                    />
                                </AccessControl>
                            </div>
                        </div>
                    </div>

                    <div className="table-responsive tableSection manageLlmMainWrapper">
                        <div className="manageLlmWrapper">
                            <table className="table  border-0 mb-0">
                                <thead>
                                    <tr className="tableSearchFields">
                                        <SearchFields
                                            searchData={searchData}
                                            filters={filters}
                                            handleSearchChange={handleSearchChange}
                                        />
                                        <th className="border-0">
                                            <div className="d-flex align-items-center w-100">
                                                <ResetBtn handleResetClick={handleReset} />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>

                            </table>
                            <div className="tableContainer scrollBarDesign">
                                <table className="table table-hover manageLlmWrapper">
                                    <thead>
                                        <tr className="TableHeader">
                                            <th >
                                                {t("Name")}
                                            </th>
                                            <th >
                                                {t("Prompt type")}
                                            </th>
                                            <th>
                                                <AccessControl
                                                    requiredPermissions={[
                                                        {
                                                            permission: "Content creation",
                                                            update: true,
                                                            delete: true,
                                                        },
                                                    ]}
                                                    actions={true}
                                                    strict={false}
                                                >
                                                    {t("Action")}
                                                </AccessControl>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <SpinnerWrapper headerLength={9} />
                                        ) : (
                                            <>
                                                {llmPrompts && llmPrompts.length > 0 ? (
                                                    llmPrompts.map((llmPrompt, index) => {
                                                        return (
                                                            <tr
                                                                key={llmPrompt.id}
                                                                className="border-bottom align-middle"
                                                                data-label="Name"
                                                            >
                                                                <td>
                                                                    {llmPrompt.name}
                                                                </td>
                                                                <td>
                                                                    {llmPrompt.promptType}
                                                                </td>
                                                                <td className="table-action-icons">
                                                                    <AccessControl
                                                                        requiredPermissions={[
                                                                            {
                                                                                permission: "Content creation",
                                                                                delete: true,
                                                                                update: true,
                                                                            },
                                                                        ]}
                                                                        actions={true}
                                                                        strict={false}
                                                                    >
                                                                        <AccessControl
                                                                            requiredPermissions={[
                                                                                {
                                                                                    permission: "Content creation",
                                                                                    update: true,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Link
                                                                                to={`/llm-prompt/${llmPrompt.id}`}
                                                                                title={t("Edit")}
                                                                            >
                                                                                <EditIcon />
                                                                            </Link>
                                                                        </AccessControl>
                                                                    </AccessControl>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <NoRecords headerLength={4} />
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>


                        {!loading && (
                            <div className="pagination d-block">
                                <PaginationNew
                                    currentPage={searchData.currentPage}
                                    totalPages={paginationData.totalPages}
                                    totalRecords={paginationData.totalRecords}
                                    recordsPerPage={searchData.recordsPerPage}
                                    onItemsPerPageChange={handleItemsPerPageChange}
                                    onPageChange={(newPage: any) => handlePageChange(newPage)}
                                />
                            </div>
                        )}
                    </div>

                </div>
                <div className="row backPadding">
                    <div className="col-md-6 align-self-center">
                        <Link to="/manage-content-creation" className="back-btn text-decoration-underline">
                            {t("Back")}
                        </Link>
                    </div>
                </div>
            </>
        </AccessControl >
    );
};

export default translate(ManageLlmPrompts);
